module.exports = __webpack_public_path__ + "img/template_lead.b014fa56.svg";